import type { CSSProperties } from 'react';
import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { colors, typography } = themeVariables;

export interface TopBannerRootCSS extends CSSProperties {
  '--topBannerPosition'?: string;
}

export const root = css`
  position: var(--topBannerPosition, relative);
  top: 0;
  z-index: 10;
  display: flex;
  justify-content: space-between;
  width: 100%;
  left: 0;
  right: 0;
  transition: color 0.3s ease-in-out, background-color 0.3s ease-in-out;
  container-type: inline-size;
  container-name: top-banner;
`;

export const arrowButton = css`
  background: none;
  border: none;
  /* Buttons don't inherit color by default; needed so the Icon's currentColor fill follows textColor */
  color: inherit;

  /* Narrow banners give the arrows' space over to the message text instead */
  @container top-banner (max-width: 767px) {
    display: none;
  }

  &:disabled {
    visibility: hidden;
  }
`;

export const message = css`
  display: none;
  height: 36px;
  padding: 0 6px;
  font-family: var(${typography.body.fontFamily});
  font-weight: 600;
  font-size: var(${typography.body.sizes.sm.fontSize});
  line-height: var(${typography.body.sizes.sm.lineHeight});

  &[aria-hidden='false'] {
    display: flex;
    align-items: center;
    /* Absorb all free space so the text stays centred whether or not the arrows show */
    flex: 1;
    justify-content: center;
  }
`;

export const textColor = {
  ['Dark']: css`
    &,
    a {
      color: var(${colors.content.default});
    }
  `,

  ['Light']: css`
    &,
    a {
      color: var(${colors.content.action});
    }
  `,
};
